import { createContext } from 'react';

const senderidContext = createContext();

export default senderidContext;
